const DomHelper = require('../../../../client/clientjs/dom-helper.js')

module.exports = () => {
  const images = DomHelper.queryAll('img')
  images.forEach(element => {
    element.onerror = () => {
      DomHelper.addClass(element, 'lazyerror')
    }
  })
}
